import { parseSurvey, type Survey } from "./schema";

export async function loadSurvey(url: string): Promise<Survey> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`アンケート定義の取得に失敗しました (status=${res.status})`);
  }
  const json = await res.json();
  return parseSurvey(json);
}
